import type { CompanySubscriptionRow, SubscriptionTier } from '../../../../services/subscriptionService';

/**
 * Effective tier: paid tiers fall back to 'free' once the subscription window
 * has lapsed so the table reflects what the user actually experiences.
 */
export function effectiveTier(row: CompanySubscriptionRow, now: Date): SubscriptionTier {
  if (row.tier === 'free') return 'free';
  const expires = row.expires_at ? new Date(row.expires_at) : null;
  if (!expires || expires <= now) return 'free';
  return row.tier;
}

/** Sort order used to surface paid tiers above free ones in the list. */
export const tierSortOrder: Record<SubscriptionTier, number> = {
  plus: 0,
  basic: 1,
  free: 2,
};
